<template>
    <button
        type="button"
        class="btn dark circle"
        :title="message"
        @click="displayMessage()"
    >
        <img src="@/assets/pictos/info.svg" :alt="message" />
    </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        message: {
            type: String,
            required: true,
        },
    },

    setup(props)
    {
        function displayMessage()
        {
            alert(props.message);
        }

        return {
            displayMessage,
        };
    },
})
</script>
